import { useCallback, useEffect, useRef, useState } from 'react'
import parse from 'html-react-parser'
import { useCollapse } from 'react-collapsed'

import { ReactComponent as TermsSvg } from '../assets/ilustraciones/terms.svg'
import { ReactComponent as ExpandMoreSvg } from '../assets/ilustraciones/expand_more.svg'
import { ReactComponent as ExpandLessSvg } from '../assets/ilustraciones/expand_less.svg'
import copys from '../utils/copys'

import * as gtmService from '../services/gtmService';
import { PromotionDetail } from '../models/promotions'
import { useAuthContext } from '../hooks/useAuthContext'

type DetailInfoCardProps = {
  html: string;
  promo: PromotionDetail;
}
const DetailInfoCard = ({ html, promo }: DetailInfoCardProps) => {

  const { userData } = useAuthContext();

  const divRef = useRef<HTMLDivElement>(null);
  const [isExpanded, setExpanded] = useState(false);
  const [isExpansible, setIsExpansible] = useState(false);

  const { getCollapseProps, getToggleProps } = useCollapse({
    collapsedHeight: 120,
    isExpanded
  });

  useEffect(() => {
    if (divRef.current) {
      const height = divRef.current.offsetHeight;
      setIsExpansible(height >= 120);
    }
  }, []);

  const toggleCollapse = useCallback(() => {
    gtmService.pushEvent({
      event: "interaction_detail_coupon",
      section: "CDP",
      user_id: userData.user?.id,
      user_type: 'consumidor',
      promotion_id: promo.id,
      promotion_name: promo.name,
      creative_name: "Banner Principal",
      creative_slot: "banner_superior",
      label: isExpanded ? copys.buttonShowLess : copys.buttonShowMore
    })
    setExpanded((prevExpanded) => !prevExpanded);
  }, [userData.user?.id, isExpanded, promo.id, promo.name])

  return (
    <div className='flex flex-col p-3 items-start gap-2 rounded-xl bg-white'>
      <div className="flex items-center gap-2">
        <TermsSvg />
        <div className='text-black font-libre-franklin font-semibold text-xl'>
          {copys.generalConditionsPromo}
        </div>
      </div>
      <div {...getCollapseProps()}>
        <div ref={divRef} id='terms' className='font-roboto text-sm font-normal text-text_strong w-full px-7 pb-3'>
          {html && parse(html)}
        </div>
      </div>
      {
        isExpansible && (
          <div className='w-full flex justify-center'>
            <button {...getToggleProps({ onClick: () => toggleCollapse() })} className='text-center text-text_strong font-roboto text-base font-semibold'>
              <div className='flex items-center gap-1'>
                <div>
                  {isExpanded ? copys.buttonShowLess : copys.buttonShowMore}
                </div>
                {isExpanded ? <ExpandLessSvg /> : <ExpandMoreSvg />}
              </div>
            </button>
          </div>
        )
      }
    </div>

  )
}

export default DetailInfoCard
